'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
}); // Fonts

var primaryFontFamily = exports.primaryFontFamily = ['IBM Plex Sans', 'Lucida Grande', 'Tahoma', 'Verdana', 'Arial', 'sans-serif'];
var secondaryFontFamily = exports.secondaryFontFamily = ['IBM Plex Serif', 'Gudea', 'Lucida Grande', 'Tahoma', 'Verdana', 'Arial', 'sans-serif']; // Typography presets

var typography = exports.typography = {
  // The default class already includes the `--normal` and `--primary` variations
  Text: {
    fontFamily: primaryFontFamily,
    color: 'var(--primary)',
    fontSize: 14,
    lineHeight: '1.57',
    fontWeight: 'normal'
  },
  // Types
  'Text--xlarge': {
    fontFamily: primaryFontFamily,
    fontSize: 20,
    lineHeight: '1.4'
  },
  'Text--large': {
    fontFamily: primaryFontFamily,
    fontSize: 16,
    lineHeight: '1.5'
  },
  'Text--normal': {
    fontFamily: primaryFontFamily,
    fontSize: 14,
    lineHeight: '1.57'
  },
  'Text--title': {
    fontFamily: secondaryFontFamily,
    fontSize: 16,
    lineHeight: '1.5'
  },
  'Text--body': {
    fontFamily: secondaryFontFamily,
    fontSize: 14,
    lineHeight: '1.57'
  },
  'Text--caption': {
    fontFamily: primaryFontFamily,
    fontSize: 12,
    lineHeight: '1.5'
  },
  // Variants
  'Text--bold': {
    fontWeight: 'bold'
  },
  'Text--regular': {
    fontWeight: 'normal'
  },
  'Text--secondary': {
    color: 'var(--secondary)'
  },
  'Text--disabled': {
    color: 'var(--disabled)'
  },
  'Text--link': {
    color: 'var(--link)'
  },
  'Text--highlighted': {
    backgroundColor: 'var(--highlighted)',
    boxShadow: '0 0 0 .2em var(--highlighted)'
  }
};